<template>
    <div id="Authentication">
        <popup ref="popup" type="center" @close="popClose">
            <div class="panel_wrap">
				<div class="panel_head">
                    <img class="head_img" :src="require(`../views/img/${identity==2?'img_icon_80':identity==3?'img_icon_79':'img_icon_81'}.png`)" alt="">
                    <div class="head_main">
                        <div class="head_title">{{identity==2?'学生身份认证':identity==3?'教师身份认证':'我的团队'}}</div>
                        <div class="head_desc">{{identity==2?'懒人办公针对学生给与的最大回馈，学生身份认证成功之后将享受最低包月9.9元/连续包月的学生专属价格！':identity==3?'懒人力公针对老师给与的最大回馈，老师身份认证成功之后将享受连续包月每月-10元的老师专属价格！':'企业和个人用户会员权益无差别，企业会员最大的优势在于管理员可以统一查看和管理所有成员文档！'}}</div>
                    </div>
                </div>
                <div class="panel_content">
                    <div class="form_part">
                        <div class="part_title">
                            <div class="part_no"><div class="no_num">1</div></div>
                            <div class="title_main">
                                <div class="title_text">基本信息</div>
                                <div class="title_tips">仅用于信息认证，严格保密</div>
                            </div>
                        </div>
                        <div class="part_content">
                            <div class="form_item">
                                <el-input :disabled="form.status<=1?true:false" v-model="form.name" :placeholder="identity==4?'公司全称':'真实姓名'"></el-input>
                            </div>
                            <div class="form_item">
                                <el-input :disabled="form.status<=1?true:false" v-model="form.card_no" :placeholder="identity==4?'统一社会信用代码':'身份证号'"></el-input>
                            </div>
                        </div>
                    </div>
                    <div class="form_part">
                        <div class="part_title">
                            <div class="part_no"><div class="no_num">2</div></div>
                            <div class="title_main">
                                <div class="title_text">联系方式</div>
                                <div class="title_tips">便于紧急联系</div>
                            </div>
                        </div>
                        <div class="part_content">
                            <div class="form_item">
                                <el-input :disabled="form.status<=1?true:false" v-model="form.phone" placeholder="手机号码"></el-input>
                            </div>
                            <div class="form_item" v-if="!form.id||form.status==2">
                                <el-input style="width:240px;margin-right:12px;" v-model="form.code" placeholder="验证码"></el-input>
                                <el-button @click="getCode" style="width:120px;" :disabled="!form.phone||coding" type="info">{{ coding?second+'s后重试':'获取验证码' }}</el-button>
                            </div>
                        </div>
                    </div>
                    <div class="form_part">
                        <div class="part_title">
                            <div class="part_no"><div class="no_num">3</div></div>
                            <div class="title_main">
                                <div class="title_text">上传材料</div>
                                <div class="title_tips">清晰展示相关信息</div>
                            </div>
                        </div>
                        <div class="part_content">
                            <div class="upload_part">
                                <el-image class="upload_img" :src="form.auth_img?form.auth_img:require('./img/img_icon_02.png')" alt=""></el-image>
                                <div class="upload_label">点此上传{{ identity==2?'学生证或校园一卡通':identity==3?'教师资格证书':'企业营业执照' }}照片</div>
                                <input v-if="form.status==2||!form.id" class="upload_file_input" ref="fileInput" accept=".jpg,.png" type="file" @change="inputUpload" title="">
                            </div>
                        </div>
                    </div>
                    <div class="form_part">
                        <div class="part_title">
                            <div class="part_no"><div class="no_num">4</div></div>
                            <div class="title_main">
                                <div class="title_text">等待人工审核 → 成功 → 享受专属福利！</div>
                            </div>
                        </div>
                        <div class="part_content no-bodder">
                            <div class="last_tips">工作日09:00-18:00需要1小时左右，节假日不审核</div>
                        </div>
                    </div>
                    <div class="form_bottom">
                        <el-button style="width:250px;" type="info" v-if="form.id&&form.status==0">正在审核...请耐心等待</el-button>
                        <el-button style="width:250px;" type="info" v-else-if="form.id&&form.status==1">审核通过</el-button>
                        <el-button style="width:250px;" type="info" @click="submitAuthIdentify" :loading="saveLoading" v-else>提交认证</el-button>
                        <el-button style="width:100px;margin-left:26x;">重置</el-button>
                    </div>
                </div>
			</div>
        </popup>
    </div>
</template>
<script type="text/ecmascript-6">
    import popup from "COMPONENTS/Popup.vue"
    export default {
        components:{popup},
        // props:["type"],//type  1-教师  2-学生  3-企业
        data() {
            return {
                form:{
                    name:"",
                    card_no:"",
                    phone:"",
                    code:"",
                    auth_img:""
                },
                identity:1,
                second:60,
                timer:null,
                coding:false,
                saveLoading:false
            }
        },
        created() {
			
        },
        methods: {
            show(identity){
                this.identity = identity
                this.fetchAuthIdentify()
                this.$refs.popup.show();
            },
            popClose(){
                this.$refs.popup.close();
                console.log("222")
                this.$emit('showUserInfoPop');
            },
            fetchAuthIdentify(){
                // 认证资料
                this.$http.get('/front/aixz/auth/identify/').then(res =>{
                    if(res.status=='200'){
                        if(res.data){
                            this.form = res.data
                            this.identity =  this.form.utype
                        }else{
                            this.form.utype = this.identity
                        }
                    }
                })
            },
            submitAuthIdentify(){
                // 认证资料
                this.saveLoading = true
                this.$http.post('/front/aixz/auth/identify/', this.form).then(res =>{
                    if(res.status=='200'){
                        this.$toast("资料已提交，请等待审核！");
                        this.fetchAuthIdentify()
                    }
                }).catch(res => {
                    this.$toast(res.result);
                }).finally(()=>{
                    this.saveLoading = false
                })
            },
            getCode(){
                if (!this.telNumberCheck(this.form.phone)) {
                    this.$toast("手机号输入不正确");
                    return;
                }
                this.coding = true;
                this.$http.post('/front/auth/smscode/', {
                    'phone':this.form.phone
                }).then(res => {
                    if(res.status=='200'){
                        this.$toast("验证码发送成功！");
                    }
                }).catch(res => {
                    this.clearFn();
                    this.$message({
                        message: res.result,
                        type: 'error'
                    });
                })
                this.timer = setInterval(()=> {
                    this.second--;
                    if (this.second == 0) {
                        this.clearFn();
                    }
                }, 1000)
            },
            clearFn() {
                this.coding = false;
                this.second = 60;
                clearInterval(this.timer);
            },
            inputUpload(e,type){
                let files = e.target.files;
                if(files.length > 1){
                    this.$message({
                        message: '仅支持单个文件上传',
                        type: 'warning'
                    })
                    return
                }
                let file = files[0];
                if(file.type != "image/jpeg" && file.type != "image/png"){
                    this.$message({
                        message: '仅支持JPG、PNG格式图片',
                        type: 'warning'
                    })
                    return
                }
                if(file.size > 15*1024*1024){
                    this.$message({
                        message: '请上传15M以内的图片',
                        type: 'warning'
                    })
                    return
                }
                this.uploadFile(file,type)
                this.$refs.fileInput.value = "";
            },
            async uploadFile(file,type){
                let post_url = await this.$http.get(`${FILE_API_SERVER}/api/front/upload/?file_folder=auth`).then(res => {
                    return res.data
                }).catch(e => {
                    return ""
                });
                if (!post_url) {
                    this.$message({
                        message: '很抱歉，系统出错，请重新上传！',
                        type: 'warning'
                    })
                    return
                }
                // 上传图片
                let formData = new FormData();
                formData.append("file", file, file.name);
                let fileResponse = await this.$http.post(post_url+"&storage=ali_oss", formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                    responseType: "text"
                }).then(res => {
                    return eval(res);
                }).catch(e => {
                    return "";
                });
                this.form.auth_img = fileResponse.data.file_full_url;
                console.log(this.form)
            },
            telNumberCheck(tel) {
                var pattern = /^[1][3-9][0-9]{9}$/;
                return pattern.test(tel)
            }
        },
        beforeDestroy(){
            clearInterval(this.timer);
        },
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .panel_wrap{
		width: 480px;
		background-color: #fff;
        border-radius: 4px;
        .panel_head{
            height: 110px;
            background-image: url("./img/img_icon_03.png");
            padding: 12px 26px;
            display: flex;
            .head_img{
                display: block;
                width: 64px;
                height: 64px;
                margin-right: 20px;
                flex-shrink: 0;
            }
            .head_main{
                flex-grow: 1;
                .head_title{
                    font-size: 24px;
                    line-height: 36px;
                }
                .head_desc{
                    font-size: 12px;
                    line-height: 22px;
                }
            }
        }
        .panel_content{
            padding: 0 34px 26px 24px;
            .form_part{
                padding-top: 10px;
                .part_title{
                    line-height: 30px;
                    display: flex;
                    align-items: center;
                    .part_no{
                        width: 30px;
                        height: 30px;
                        border-radius: 15px;
                        background-color: #ccc;
                        padding-top: 5px;
                        margin-right: 16px;
                        .no_num{
                            width: 20px;
                            height: 20px;
                            line-height: 20px;
                            text-align: center;
                            border-radius: 10px;
                            margin: 0 auto;
                            background-color: #424242;
                            color: #fff;
                        }
                    }
                    .title_main{
                        flex-grow: 1;
                        display: flex;
                        white-space: nowrap;
                        font-size: 12px;
                        .title_text{
                            flex-grow: 1;
                        }
                        .title_tips{
                            color: #ccc;
                        }
                    }
                }
                .part_content{
                    margin-left: 15px;
                    margin-top: 4px;
                    border-left: 1px dashed #424242;
                    padding-left: 34px;
                    &.no-bodder{
                        border-color: transparent;
                    }
                    .form_item{
                        margin-bottom: 18px;
                    }
                    .upload_part{
                        height: 90px;
                        text-align: center;
                        position: relative;
                        border: 1px dashed #ccc;
                        padding-top: 12px;
                        .upload_img{
                            width: 38px;
                        }
                        .upload_label{
                            font-size: 12px;
                            color: #ccc;
                        }
                        .upload_file_input{
                            position: absolute;
                            width: 100%;
                            height: 100%;
                            opacity: 0;
                            z-index: 1;
                            top: 0;
                            left: 0;
                            cursor: pointer;
                        }
                    }
                    .last_tips{
                        line-height: 30px;
                        color: #ccc;
                        font-size: 12px;
                        margin-bottom: 19px;
                    }
                }
            }
            .form_bottom{
                padding-left: 45px;
            }
        }
	}
</style>